import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import {environment} from '../../../environments/environment';
import {Device, GetOrganizationDevicesRequest, PostDeviceSettingsRequest} from '../models/device';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import {Simple200Response} from '../models/general';

@Injectable()
export class DeviceService {

  constructor(private httpClient: HttpClient) {
  }

  getOrganizationDevices({organizationToken}: GetOrganizationDevicesRequest): Observable<Device[]> {
    const url = `${environment.afbV2Host}org-users/self/devices`;
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});

    return this.httpClient
      .get<{ data: Device[] }>(url, {headers})
      .pipe(
        map(response => response.data)
      );
  }

  postDeviceSettings({organizationToken, organizationId, deviceSettings}: PostDeviceSettingsRequest): Observable<Simple200Response> {
    const url = `${environment.afbV1Host}orgs/${organizationId}/device-settings/batch`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${organizationToken}`,
      'Content-Type': 'application/json'
    });

    return this.httpClient
      .post<Simple200Response>(url, deviceSettings, {headers});
  }
}
